
import Dashboard from "./dashboard/dashboard";
import {ComfyProvider} from "./comfy/ComfyProvider";
import CssBaseline from '@mui/material/CssBaseline';

function App() {
  return (
      <>
      <CssBaseline />
      <ComfyProvider>
        {/* UI */}
          <Dashboard />
      </ComfyProvider>
      </>
  );
}

export default App;
